import React from 'react'
import { routes } from 'Routes'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { AppProvider } from 'contexts'
import { LOCAL_STORAGE_KEYS } from 'utils/constants'

const router = createBrowserRouter(routes)

const App: React.FC = () => {
  React.useEffect(() => {
    return () => localStorage.removeItem(LOCAL_STORAGE_KEYS.AFTER_SIGN_IN_URL)
  }, [])

  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  )
}

export default App
